export default [
    {
        path: "app-lists",
        name: "applists",
        component: () =>
            import(
            /* webpackChunkName: "AppList" */ "../pages/pushManagement/AppList.vue"
            ),
        meta: {
            title: `App List`,
        },
    },
    {
        path: "add-app",
        name: "addapp",
        component: () =>
            import(
            /* webpackChunkName: "AddApp" */ "../pages/pushManagement/AddApps.vue"
            ),
        meta: {
            title: `Add App`,
        },
    },
    {
        path: "edit-app/:id",
        name: "ediapp",
        component: () =>
            import(
            /* webpackChunkName: "EditApp" */ "../pages/pushManagement/AddApps.vue"
            ),
        meta: {
            title: `Edit App`,
        },
    },
    {
        path: "template-lists",
        name: "templatelists",
        component: () =>
            import(
            /* webpackChunkName: "TemplateLists" */ "../pages/pushManagement/TemplateList.vue"
            ),
        meta: {
            title: `Template List`,
        },
    },
    {
        path: "add-template",
        name: "addtemplate",
        component: () =>
            import(
            /* webpackChunkName: "AddTemplate" */ "../pages/pushManagement/AddTemplate.vue"
            ),
        meta: {
            title: `Add Template`,
        },
    },
    {
        path: "edit-template/:id",
        name: "editemplate",
        component: () =>
            import(
            /* webpackChunkName: "EditTemplate" */ "../pages/pushManagement/AddTemplate.vue"
            ),
        meta: {
            title: `Edit Template`,
        },
    },
    {
        path: "all-push-requests",
        name: "allpushrequests",
        component: () =>
            import(
            /* webpackChunkName: "AllPushRequests" */ "../pages/pushManagement/AllPushRequestList.vue"
            ),
        meta: {
            title: `All Push Requests`,
        },
    },
    {
        path: "send-new-push",
        name: "sentnewpush",
        component: () =>
            import(
            /* webpackChunkName: "SentNewPush" */ "../pages/pushManagement/SentNewPush.vue"
            ),
        meta: {
            title: `Send New Push`,
        },
    }
];
